/**
 * Services page initialization
 * NOTE: This file is bundled on all /services/* pages.
 * It must silently no-op when a feature's DOM is not present.
 */

import DatePickerModal from '../../components/DatePickerModal.js';
import ReadMoreToggle from '../../components/readmore.js';
import EventFilter from '../../components/EventFilter.js';
import { domReady, initOnce } from '../../utils/dom.js';

function initGroupsDatePicker() {
  const groupDataEl = document.getElementById('group-data');
  if (!groupDataEl) return;

  // Prefer dataset guard over global, but keep window.groupApp for compatibility
  initOnce(groupDataEl, 'groupsDatePicker', () => {
    if (!window.groupApp) {
      window.groupApp = new DatePickerModal('group-data', 'modal-group-title');
    }
  });
}

function initReadMore() {
  // ReadMoreToggle binds a document click listener; prevent duplicate instances.
  if (window.__readMoreInitialized) return;
  window.__readMoreInitialized = true;

  new ReadMoreToggle();
}

function initGroupsEventFilter() {
  const container = document.querySelector('.groups-events');
  if (!container) return;

  initOnce(container, 'groupsEventFilter', () => {
    new EventFilter({
      containerSelector: '.groups-events',
      itemSelector: '.group-group',
      visibleCountId: 'visible-groups-count',
      totalCountId: 'total-groups-count',
    });
  });
}

function initServices() {
  initGroupsDatePicker();
  initReadMore();
  initGroupsEventFilter();
}

domReady(initServices);
